// extracted by mini-css-extract-plugin
export default {"gdpr":"Gdpr_gdpr__029Dp","gdpr__header":"Gdpr_gdpr__header__JplRX","gdpr__text":"Gdpr_gdpr__text__L-MsX"};